import React from 'react';
import { connect } from "react-redux";
import MapComponent from "../components/MapComponent";
import DisplayActions from "../redux/DisplayRedux";
import UserAccountActions from '../redux/UserAccountRedux'

const mapStateToProps = ({ display, userAccount }) => ({
  user: userAccount.user,

  lat_sw: display.lat_sw,
  lng_sw: display.lng_sw,
  lat_ne: display.lat_ne,
  lng_ne: display.lng_ne,
  mapZoom: display.mapZoom,

  date_from: display.date_from,
  date_to: display.date_to,
  shows_per_day_min: display.shows_per_day_min,
  location_type: display.location_type,
  location_sub_type: display.location_sub_type,
  size_type: display.size_type,
  isCircuit: display.isCircuit,
  page: display.page,

  perPage: display.perPage,
  total: display.total,
  displays: display.displays,
  displaysMap: display.displaysMap,
  displaysMapMode: display.displaysMapMode,
  displaysMapMediaOwners: display.displaysMapMediaOwners,
  fetchingDisplaysMap: display.fetchingDisplaysMap,

  cart: display.cart,
  fetching: display.fetching,

  redirectTarget: userAccount.redirectTarget,

  errors: display.errors,

  client: display.client,
  brand: display.brand,
  loadingBrands: display.loadingBrands,

  countries: display.countries,

  programmatic: display.programmatic,
  amountBudget: display.amountBudget,

  poi_filters: display.poi_filters,

  audience: display.audience,
  loadingAudience: display.loadingAudience,
  excelDisplay: display.excelDisplay,
  loadingExcel:display.loadingExcel,
  editCampaignActive: display.editCampaignActive,
  editCampaign: display.editCampaign,
  currentDisplay: display.currentDisplay,
  currency: userAccount.currency,
  invoiceIssuingCountry: userAccount.invoiceIssuingCountry,
  campaignInvoiceIssuingCountry: display.campaignInvoiceIssuingCountry,
  campaignCurrency: display.campaignCurrency,
  campaignBillingCountry: display.campaignBillingCountry,
  dsp: display.dsp,
  dsps: display.dsps,
  listBundle: display.listBundle,
  isGuaranteed: display.isGuaranteed,
  initialBackup: display.initialBackup,
  hasInitialBackup: display.hasInitialBackup,
  checkingDisplaysByIds: display.checkingDisplaysByIds,
  checkDisplaysByIdsResult: display.checkDisplaysByIdsResult,
});

const mapStateToDispatch = dispatch => ({
  setBounds: (bounds, zoom) => dispatch(DisplayActions.setBounds(bounds, zoom)),
  setCoords: coords => dispatch(DisplayActions.setCoords(coords)),
  setPage: page => dispatch(DisplayActions.setPage(page)),
  setParamsFromUrl: params => dispatch(DisplayActions.setParamsFromUrl(params)),
  setMapZoom: zoom => dispatch(DisplayActions.setMapZoom(zoom)),
  getDisplays: params => dispatch(DisplayActions.getDisplaysRequest(params)),
  getDisplaysMap: params => dispatch(DisplayActions.getDisplaysMapRequest(params)),
  getDisplaysCart: params => dispatch(DisplayActions.getDisplaysCartRequest(params)),
  getBulkDisplaysCart: params => dispatch(DisplayActions.getBulkDisplaysCartRequest(params)),
  removeDisplaysCart: (id) => dispatch(DisplayActions.removeDisplaysCart(id)),
  setSizeType: (sizes) => dispatch(DisplayActions.setSizeType(sizes)),
  setLocationType: (types) => dispatch(DisplayActions.setLocationType(types)),
  setLocationSubType: (subTypes) => dispatch(DisplayActions.setLocationSubType(subTypes)),

  setProgrammatic: (programmatic) => dispatch(DisplayActions.setProgrammatic(programmatic)),
  setBudget: (amountBudget) => dispatch(DisplayActions.setBudget(amountBudget)),
  setCountries: (countries) => dispatch(DisplayActions.setCountries(countries)),

  setPoiFilters: (poiFilters) => dispatch(DisplayActions.setPoiFilters(poiFilters)),
  resetPoiFilters: () => dispatch(DisplayActions.resetPoiFilters()),

  addDisplayToCart: display =>dispatch(DisplayActions.addDisplayToCart(display)),
  addDisplayToCartById: params => dispatch(DisplayActions.addDisplayToCartByIdRequest(params)),
  addListDisplayToCart: displays => dispatch(DisplayActions.addListDisplayToCart(displays)),
  setDsp: (dsp) => dispatch(DisplayActions.setDsp(dsp)),
  removeDisplayFromCart: displayId =>
    dispatch(DisplayActions.removeDisplayFromCart(displayId)),
  removeDisplayFromCartBulk: displayIds =>
    dispatch(DisplayActions.removeDisplayFromCartBulk(displayIds)),

  getAudience: (data) => dispatch(DisplayActions.getAudienceRequest(data)),
  getDisplayInfoRequest: (id, clientId) => dispatch(DisplayActions.getDisplayInfoRequest(id, clientId)),
  cleanAudience: ()=> dispatch(DisplayActions.cleanAudience()),
  setShouldPromptLogin: (value, target) => dispatch(UserAccountActions.setShouldPromptLogin(value, target)),

  setIsGuaranteed: (isGuaranteed) => dispatch(DisplayActions.setIsGuaranteed(isGuaranteed)),
  checkDisplaysByIds: params => dispatch(DisplayActions.checkDisplaysByIdsRequest(params)),
});

export default connect(mapStateToProps, mapStateToDispatch)(MapComponent)
